import React from "react";
import { Link } from "react-router-dom";
import { Users, MoonStar, ArrowUpRight } from "lucide-react";
import { pricingRules } from "../data/site";

export default function ApartmentCard({ apt, imageOverride, waiting = false }) {
  const src = imageOverride || null; // stock fallback removed – neutral placeholder when no admin image
  return (
    <article
      data-testid={`apartment-card-${apt.slug}`}
      className="group bg-ivory border border-charcoal/10 hover:border-burgundy/40 transition-colors overflow-hidden flex flex-col"
    >
      <Link to={`/ubytovani/${apt.slug}`} className="relative aspect-[4/3] overflow-hidden bg-cream">
        {src ? (
          <img src={src} alt={apt.name} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.04]" loading="lazy" />
        ) : (
          <div className="w-full h-full" aria-hidden="true" />
        )}
      </Link>
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="font-serif text-2xl text-charcoal">{apt.name}</h3>
        <p className="mt-2 text-sm text-charcoal/70 leading-relaxed">{apt.summary}</p>
        <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-charcoal/60">
          <span className="inline-flex items-center gap-1.5"><Users size={13} className="text-gold" /> {apt.capacity}</span>
          <span className="inline-flex items-center gap-1.5"><MoonStar size={13} className="text-gold" /> min.&nbsp;{apt.minNights}&nbsp;noci</span>
        </div>
        <div className="mt-5 pt-5 border-t border-charcoal/10 flex items-end justify-between">
          <div>
            <div className="font-serif text-lg text-burgundy">{pricingRules.perPersonSummer}&nbsp;Kč <span className="text-xs text-charcoal/60">/ osoba / noc</span></div>
            <div className="text-[11px] text-charcoal/55 mt-0.5">Listopad–březen: {pricingRules.perPersonWinter}&nbsp;Kč / osoba / noc</div>
          </div>
          <Link to={`/ubytovani/${apt.slug}`} className="inline-flex items-center gap-1 text-sm text-charcoal group-hover:text-burgundy shrink-0">
            Detail <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </article>
  );
}
